import Vue from 'vue';
import querystring from 'querystring';
import * as Cursos from '@lib/Cursos';
import { Curso } from '@lib/Cursos/Curso.nav';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';


export class ControladorDeCurso extends Vue
{

    public Curso: Curso;
    public Resultado: Resultado;


    public async Iniciar( curso: Curso )
    {
        if ( curso )
        {
            this.Curso = curso;
            this.Resultado = await Resultado.create( this.Curso.Id );
            if ( this.Resultado )
                await this.Resultado.CargarRespuestas();
        }
        this.$emit( 'change' );

    }

    public async IniciarCurso(): Promise<boolean>
    {
        if ( !this.Resultado )
        {
            let e = await this.Curso.Iniciar();
            this.Resultado = await Resultado.create( this.Curso.Id );
        }
        return this.Resultado && this.Resultado.Existe;
    }

    public async FinalizarCurso(): Promise<boolean>
    {
        this.Resultado = await Resultado.create( this.Curso.Id );
        if ( this.Resultado )
            await this.Resultado.CargarRespuestas();
        return this.Resultado && this.Resultado.Existe;
    }
}

const Controlador = new ControladorDeCurso();
export { Controlador };

